import {
  IMixpanelService,
  MIXPANEL_EVENT_IDENTIFIERS,
  MIXPANEL_EVENT_TYPES
} from '../../constans/mixpanel-contants';
import { authService } from './auth-service';
import { IDecodedJwtToken } from '../../store/auth-store/auth-store';
import { protectedTrackApiClient } from '../../api/api-fetcher/api-client';
import { getPodiumInfoStore } from '../../store/podium-info-store/podium-info-store-instance';
import { Buffer } from 'buffer';


class MixpanelService implements IMixpanelService {
  private decodedToken: IDecodedJwtToken | null;

  constructor (
    private readonly presenterEmbedId: string,
  ) { }

  public track = (
    identifier: MIXPANEL_EVENT_IDENTIFIERS | null,
    type: MIXPANEL_EVENT_TYPES | null,
    options?: Record<string, unknown>,
  ): void => {
    if (!authService.getJwtToken(this.presenterEmbedId)) return;
    const event = this.buildEvent(identifier, type);
    const userInfo = this.getUserInfo();
    const applicationParam = { 'application': 'Podium' };
    const properties = { properties: { ...userInfo, ...this.getPresentationInfo(), ...options }};
    const mixpanelParameters = { user_id: userInfo['User ID'], ...properties };
    protectedTrackApiClient.post('analytic/events', { event, ...applicationParam, ...mixpanelParameters })
      .catch(() => {});
  };

  private getUserInfo = () => {
    this.decodedToken = authService.decodeJwt(authService.getJwtToken(this.presenterEmbedId) || '');
    const userId = this.decodedToken?.knovioUserId
      ? this.decodedToken?.knovioUserId
      : this.getNumberFromUuid(this.decodedToken?.userId);

    return {
      'Account ID': this.decodedToken?.accountId,
      'Account Organization Name': this.decodedToken?.accountOrganizationName,
      'Account Plan ID': this.decodedToken?.accountPlanId,
      'User ID': userId
    };
  };

  private getPresentationInfo = () => {
    return {
      'Knovio Title': getPodiumInfoStore().presentationInfo?.presentationName,
      'Knovio ID': getPodiumInfoStore().getPresentationId()
    };
  };

  private buildEvent = (identifier: MIXPANEL_EVENT_IDENTIFIERS | null, type: MIXPANEL_EVENT_TYPES | null): string => {
    return `Podium.${identifier}${type ? '.' + type : ''}`;
  };

  private getNumberFromUuid = (uuid?: string) => {
    const buffer = uuid && Buffer.from(uuid);
    const result = buffer && buffer.readUInt32BE(0);

    return result;
  };
}

export default MixpanelService;
